import { tokens } from "../theme";
// import React, { useEffect, useState } from 'react';

// const [pumps, setPumps] = useState(null);
// const [data2, setData2] = useState(null);
// const [loading, setLoading] = useState(true);
// const [error, setError] = useState(null);

// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       // Fetch data from the first API
//       const response1 = await fetch('https://api.example.com/pumps');
//       if (!response1.ok) {
//         throw new Error('Failed to fetch data from API 1');
//       }
//       const result1 = await response1.json();
//       setPumps(result1);

//       // Fetch data from the second API
//       const response2 = await fetch('https://api.example.com/data2');
//       if (!response2.ok) {
//         throw new Error('Failed to fetch data from API 2');
//       }
//       const result2 = await response2.json();
//       setData2(result2);

//       setLoading(false);
//     } catch (error) {
//       setError(error.message);
//       setLoading(false);
//     }
//   };

//   fetchData();
// }, []);

export const mockDataTeam = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    age: 35,
    phone: "(665)121-5454",
    access: "admin",
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    age: 42,
    phone: "(421)314-2288",
    access: "manager",
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    access: "user",
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    age: 16,
    phone: "(921)425-6742",
    access: "admin",
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    age: 31,
    phone: "(421)445-1189",
    access: "user",
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    age: 150,
    phone: "(232)545-6483",
    access: "manager",
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    age: 44,
    phone: "(543)124-0123",
    access: "user",
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    age: 36,
    phone: "(222)444-5555",
    access: "user",
  },
  {
    id: 9,
    name: "Harvey Roxie",
    email: "harveyroxie@gmail.com",
    age: 65,
    phone: "(444)555-6239",
    access: "admin",
  },
];

export const mockDataContacts = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    age: 35,
    phone: "(665)121-5454",
    address: "0912 Won Street, Alabama, SY 10001",
    city: "New York",
    zipCode: "10001",
    registrarId: 123512,
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    age: 42,
    phone: "(421)314-2288",
    address: "1234 Main Street, New York, NY 10001",
    city: "New York",
    zipCode: "13151",
    registrarId: 123512,
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    address: "3333 Want Blvd, Estanza, NAY 42125",
    city: "New York",
    zipCode: "87281",
    registrarId: 4132513,
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    age: 16,
    phone: "(921)425-6742",
    address: "1514 Main Street, New York, NY 22298",
    city: "New York",
    zipCode: "15551",
    registrarId: 123512,
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    age: 31,
    phone: "(421)445-1189",
    address: "11122 Welping Ave, Tenting, CD 21321",
    city: "Tenting",
    zipCode: "14215",
    registrarId: 123512,
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    age: 150,
    phone: "(232)545-6483",
    address: "1234 Canvile Street, Esvazark, NY 10001",
    city: "Esvazark",
    zipCode: "10001",
    registrarId: 123512,
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    age: 44,
    phone: "(543)124-0123",
    address: "22215 Super Street, Everting, ZO 515234",
    city: "Evertin",
    zipCode: "51523",
    registrarId: 123512,
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    age: 36,
    phone: "(222)444-5555",
    address: "4123 Ever Blvd, Wentington, AD 142213",
    city: "Esteras",
    zipCode: "44215",
    registrarId: 512315,
  },
  {
    id: 9,
    name: "Harvey Roxie",
    email: "harveyroxie@gmail.com",
    age: 65,
    phone: "(444)555-6239",
    address: "51234 Avery Street, Cantory, ND 212412",
    city: "Colunza",
    zipCode: "111234",
    registrarId: 928397,
  },
  {
    id: 10,
    name: "Enteri Redack",
    email: "enteriredack@gmail.com",
    age: 42,
    phone: "(222)444-5555",
    address: "4123 Easer Blvd, Wentington, AD 142213",
    city: "Esteras",
    zipCode: "44215",
    registrarId: 533215,
  },
  {
    id: 11,
    name: "Steve Goodman",
    email: "stevegoodmane@gmail.com",
    age: 11,
    phone: "(444)555-6239",
    address: "51234 Fiveton Street, CunFory, ND 212412",
    city: "Colunza",
    zipCode: "1234",
    registrarId: 92197,
  },
];

export const mockDataInvoices = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    cost: "21.24",
    phone: "(665)121-5454",
    date: "03/12/2022",
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    cost: "1.24",
    phone: "(421)314-2288",
    date: "06/15/2021",
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    cost: "11.24",
    phone: "(422)982-6739",
    date: "05/02/2022",
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    cost: "80.55",
    phone: "(921)425-6742",
    date: "03/21/2022",
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    cost: "1.24",
    phone: "(421)445-1189",
    date: "01/12/2021",
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    cost: "63.12",
    phone: "(232)545-6483",
    date: "11/02/2022",
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    cost: "52.42",
    phone: "(543)124-0123",
    date: "02/11/2022",
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    cost: "21.24",
    phone: "(222)444-5555",
    date: "05/02/2021",
  },
];

export const mockTransactions = [
  {
    txId: "01e4dsa",
    user: "Manoj Kumar",
    date: "03-02-2025",
    cost: "E-009",
  },
  , {
    txId: "01e4dsa",
    user: "GPS Move",
    date: "03-02-2025",
    cost: "E-009",
  },
  {
    txId: "01e4dsa",
    user: "Installation",
    date: "03-02-2025",
    cost: "E-008",
  }, {
    txId: "01e4dsa",
    user: "System ",
    date: "03-02-2025",
    cost: "E-003",
  }, {
    txId: "01e4dsa",
    user: "Payment",
    date: "03-02-2025",
    cost: "E-021",
  }, {
    txId: "01e4dsa",
    user: "GPS Move",
    date: "03-02-2025",
    cost: "E-009",
  },
];

export const mockBarData = [
  {
    country: "AD",
    "hot dog": 137,
    "hot dogColor": "hsl(229, 70%, 50%)",
    burger: 96,
    burgerColor: "hsl(296, 70%, 50%)",
    kebab: 72,
    kebabColor: "hsl(97, 70%, 50%)",
    donut: 140,
    donutColor: "hsl(340, 70%, 50%)",
  },
  {
    country: "AE",
    "hot dog": 55,
    "hot dogColor": "hsl(307, 70%, 50%)",
    burger: 28,
    burgerColor: "hsl(111, 70%, 50%)",
    kebab: 58,
    kebabColor: "hsl(273, 70%, 50%)",
    donut: 29,
    donutColor: "hsl(275, 70%, 50%)",
  },
  {
    country: "AF",
    "hot dog": 109,
    "hot dogColor": "hsl(72, 70%, 50%)",
    burger: 23,
    burgerColor: "hsl(96, 70%, 50%)",
    kebab: 34,
    kebabColor: "hsl(106, 70%, 50%)",
    donut: 152,
    donutColor: "hsl(256, 70%, 50%)",
  },
  {
    country: "AG",
    "hot dog": 133,
    "hot dogColor": "hsl(257, 70%, 50%)",
    burger: 52,
    burgerColor: "hsl(326, 70%, 50%)",
    kebab: 43,
    kebabColor: "hsl(110, 70%, 50%)",
    donut: 83,
    donutColor: "hsl(9, 70%, 50%)",
  },
  {
    country: "AI",
    "hot dog": 81,
    "hot dogColor": "hsl(190, 70%, 50%)",
    burger: 80,
    burgerColor: "hsl(325, 70%, 50%)",
    kebab: 112,
    kebabColor: "hsl(54, 70%, 50%)",
    donut: 35,
    donutColor: "hsl(285, 70%, 50%)",
  },
  {
    country: "AL",
    "hot dog": 66,
    "hot dogColor": "hsl(208, 70%, 50%)",
    burger: 111,
    burgerColor: "hsl(334, 70%, 50%)",
    kebab: 167,
    kebabColor: "hsl(182, 70%, 50%)",
    donut: 18,
    donutColor: "hsl(76, 70%, 50%)",
  },
  {
    country: "AM",
    "hot dog": 80,
    "hot dogColor": "hsl(87, 70%, 50%)",
    burger: 47,
    burgerColor: "hsl(141, 70%, 50%)",
    kebab: 158,
    kebabColor: "hsl(224, 70%, 50%)",
    donut: 49,
    donutColor: "hsl(274, 70%, 50%)",
  },
];

export const mockPieData = [
  {
    id: "hack",
    label: "hack",
    value: 239,
    color: "hsl(104, 70%, 50%)",
  },
  {
    id: "make",
    label: "make",
    value: 170,
    color: "hsl(162, 70%, 50%)",
  },
  {
    id: "go",
    label: "go",
    value: 322,
    color: "hsl(291, 70%, 50%)",
  },
  {
    id: "lisp",
    label: "lisp",
    value: 503,
    color: "hsl(229, 70%, 50%)",
  },
  {
    id: "scala",
    label: "scala",
    value: 584,
    color: "hsl(344, 70%, 50%)",
  },
];




// export const mockLineData = [
//   {
//     id: "Water Flow Rate (L/min)",
//     color: tokens("dark").blueAccent[300],
//     data: [
//       { x: "00:00", y: 0 }, // Scaled up by 2x
//       { x: "06:00", y: 100 }, // Scaled up by 2x
//       { x: "12:00", y: 600 }, // Scaled up by 2x
//       { x: "18:00", y: 100 }, // Scaled up by 2x
//      // { x: "24:00", y: 0 }, // Scaled up by 2x
//     ],
//   },
//   {
//     id: "Solar Energy Generation (kWh)",
//     color: tokens("dark").redAccent[200],
//     data: [
//       { x: "00:00", y: 0 },   // No energy at night
//       { x: "06:00", y: 250 }, // Energy at sunrise
//       { x: "12:00", y: 1000 }, // Energy at peak sunlight
//       { x: "18:00", y: 60 }, // Energy at sunset
//     //  { x: "24:00", y: 30 },   // No energy at night
//     ],
//   },
//   {
//     id: "Pump Power Consumption (kW)",
//     color: tokens("dark").grey[400],
//     data: [
//       { x: "00:00", y: 2 }, // Scaled down by 2x
//       { x: "06:00", y: 50 },  // Scaled down by 2x
//       { x: "12:00", y: 300 }, // Scaled down by 2x
//       { x: "18:00", y: 100 }, // Scaled down by 2x
//      // { x: "24:00", y: 0.3 },  // Scaled down by 2x
//     ],
//   },
// ];

export const mockLineData = [
  {
    id: "Water Flow Rate (L/min)",
    color: tokens("dark").blueAccent[300],
    data: [
      { x: "00:00", y: 0 },
      { x: "06:00", y: 100 },
      { x: "12:00", y: 600 },
      { x: "18:00", y: 100 },
      { x: "24:00", y: 0 }, // Keep this for proper closure
    ],
  },
  {
    id: "Solar Energy Generation (kWh)",
    color: tokens("dark").redAccent[200],
    data: [
      { x: "00:00", y: 0 },
      { x: "06:00", y: 25 },
      { x: "12:00", y: 100 },
      { x: "18:00", y: 60 },
      { x: "24:00", y: 0 },
    ],
  },
  {
    id: "Pump Power Consumption (kW)",
    color: tokens("dark").grey[400],
    data: [
      { x: "00:00", y: 2 },
      { x: "06:00", y: 50 },
      { x: "12:00", y: 300 },
      { x: "18:00", y: 100 },
      { x: "24:00", y: 2 },
    ],
  },
];

const pumpdata={
  "has_next": false,
  "has_prev": false,
  "page": 1,
  "pages": 1,
  "per_page": 5,
  "pumps": [
    {id:1,
      "_id": "67b2dc23fa9ba5c279fe86eb",
      "consumer": "John Doe",
      "created_date": "Mon, 17 Feb 2025 06:50:08 GMT",
      "geolocation": [
        28.7041,
        77.1025
      ],
      "imei": "1234567890",
      "model_number": "MN98765",
      "pump_connectivity": true,
      "pump_name": "Solar Pump Alpha",
      "pump_running": false,
      "rating": "5 HP",
      "serial_number": "SN123456",
      "sim_iccid": "ICCID987654321",
      "total_running_time": 0,
      "total_water_discharge": 0
    }
  ],
  "total": 1
}

export const mockDataPumps =pumpdata.pumps
// [
  
//   {
//     id: 1,
//     imei: "123456789012345",
//     dcVoltage: "48V",
//     dcCurrent: "10A",
//     acOutputCurrent: "5A",
//     power: "500W",
//     driveFrequency: "50Hz",
//     energy: "2.5kWh",
//     runningHours: "120h",
//     waterDischarge: "5000L",
//     status: "on", // "on" or "off"
//     networkConnectivity: "Connected",
//     customerName: "Rohit Kumar",
//   },
//   {
//     id: 2,
//     imei: "987654321098765",
//     dcVoltage: "24V",
//     dcCurrent: "8A",
//     acOutputCurrent: "4A",
//     power: "400W",
//     driveFrequency: "60Hz",
//     energy: "1.8kWh",
//     runningHours: "90h",
//     waterDischarge: "4000L",
//     status: "off", // "on" or "off"
//     networkConnectivity: "Disconnected",
//     customerName: "Santosh Singh",
//   },
//   {
//     id: 3,
//     imei: "567890123456789",
//     dcVoltage: "36V",
//     dcCurrent: "12A",
//     acOutputCurrent: "6A",
//     power: "600W",
//     driveFrequency: "50Hz",
//     energy: "3.0kWh",
//     runningHours: "150h",
//     waterDischarge: "6000L",
//     status: "on", // "on" or "off"
//     networkConnectivity: "Connected",
//     customerName: "Joginder Tyagi",
//   },
 
// ];

export const mockDataConsumers = [
  {
    id: 1,
    name: "Ramesh Kumar",
    serviceNo: "AGRI-2023-001",
    agricultureDetails: {
      farmSize: "5 Acres",
      primaryCrops: ["Wheat", "Mustard"]
    },
    contact: {
      phone: "+91 98765 43210",
      email: "ramesh.kumar@farmer.com"
    },
    address: {
      line1: "Village: Nangla Gujran",
      line2: "Tehsil: Kharkhoda",
      city: "Sonipat",
      state: "Haryana",
      pincode: "131402"
    },
    registrationDate: "2023-01-15",
    status: "Active"
  },
  {
    id: 2,
    name: "Sunita Devi",
    serviceNo: "AGRI-2023-002",
    agricultureDetails: {
      farmSize: "3.2 Acres",
      primaryCrops: ["Rice", "Vegetables"]
    },
    contact: {
      phone: "+91 87654 32109",
      email: "sunitadevi@organicfarm.com"
    },
    address: {
      line1: "Farm House No. 45",
      line2: "Near Krishi Vigyan Kendra",
      city: "Ludhiana",
      state: "Punjab",
      pincode: "141004"
    },
    registrationDate: "2023-02-20",
    status: "Active"
  },
  {
    id: 3,
    name: "Vijay Singh",
    serviceNo: "AGRI-2023-003",
    agricultureDetails: {
      farmSize: "8 Acres",
      primaryCrops: ["Sugarcane", "Maize"]
    },
    contact: {
      phone: "+91 76543 21098",
      email: "vijay.singh@agri.com"
    },
    address: {
      line1: "Plot No. 78",
      line2: "Saharanpur Road",
      city: "Meerut",
      state: "Uttar Pradesh",
      pincode: "250001"
    },
    registrationDate: "2023-03-10",
    status: "Inactive"
  },
];
